import classNames from 'classnames';
import Link from 'next/link';
import { CSSProperties, HTMLAttributeAnchorTarget, forwardRef, useMemo } from 'react';

import { replaceOrAddLocale, useLocale } from '../../helpers/LangHelper';
import { BusinessHubMenuItemType } from '../../types/BusinessIndustries';
import styles from './business-hub-menu-item.module.scss';
import { useRouter } from 'next/router';

interface BusinessHubMenuDropdownProps {
    items?: BusinessHubMenuItemType[];
    attributes?: { [key: string]: { [key: string]: string } | undefined };
    popperStyles: { [key: string]: CSSProperties };
}

const BusinessHubMenuDropdown: React.ForwardRefRenderFunction<HTMLDivElement, BusinessHubMenuDropdownProps> = (props, ref) => {
    const { items, popperStyles, attributes } = props;

    const { locale } = useLocale();
    const route = useRouter();

    const activeUrl = useMemo(() => {
        if (route.isFallback) return '';

        return route.query.slug && Array.isArray(route.query.slug) ? `/${route.query.slug.join('/')}` : route.query.slug;
    }, [route]);

    const getAnchorTarget = (href: string): HTMLAttributeAnchorTarget => {
        if (!href) return '_blank';
        if (href.startsWith('http://') || href.startsWith('https://')) {
            let domain = new URL(href);
            if (typeof window !== 'undefined' && domain.origin === window.location.origin) {
                return '_self';
            }
            return '_blank';
        }

        return '_self';
    };

    return (
        <div ref={ref} className={styles.dropdownContainer} style={popperStyles.popper} {...(attributes?.popper || {})}>
            {items?.map((item) => {
                const href = replaceOrAddLocale(item.url || '', locale);
                const target = getAnchorTarget(href);

                return (
                    <Link
                        key={item.key}
                        href={href}
                        className={classNames(styles.menuItem, styles.child, { [styles.active]: activeUrl === href })}
                        target={target}
                        aria-label={item.name}
                    >
                        {item.name}
                    </Link>
                );
            })}
        </div>
    );
};

export default forwardRef(BusinessHubMenuDropdown);
